import { DATE_PARAM_FORMAT, US_DATE_FORMAT_WITH_YEAR } from "config"
import dayjs from "dayjs"

const ONE_MINUTES_IN_MILLISECONDS = 60 * 1000

export const getTimeToRefreshOnNextDay = () => {
  const timeToMidnight = dayjs().endOf("day").diff(dayjs(), "millisecond")
  const timeToRefresh = timeToMidnight + ONE_MINUTES_IN_MILLISECONDS

  return timeToRefresh
}

export const sortByStartTime = (a: string, b: string) => {
  return dayjs(a).isBefore(dayjs(b)) ? -1 : 1
}

export const isFutureDate = (createdFor?: string) => {
  if (!createdFor) {
    return false
  }

  return dayjs(createdFor).utc(true).local().isAfter(dayjs().endOf("day"))
}

export const getScheduleStopDate = (createdFor?: string) => {
  if (!createdFor) {
    return undefined
  }

  const stopDate = dayjs(createdFor)
    .utc(true)
    .local()
    .startOf("day")
    .format(DATE_PARAM_FORMAT)

  return stopDate
}

export const getUSDisplayDateWithYear = (date?: string) => {
  return date ? dayjs(date).format(US_DATE_FORMAT_WITH_YEAR) : ""
}

export const getNowUtcIso = () => {
  return dayjs().utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
}
